module.exports = __webpack_public_path__ + "img/symbol_2.c8dd8715.png";